import { ERROR_MESSAGES } from './error-messages';
import { charLimitRegex, digitRegex, spaceRegex, specialCharRegex, textLowerCaseRegex, textUpperCaseRegex } from './regex';

export const regexAndErrorMessageMapping = [
    { regex: charLimitRegex, errorMessage: ERROR_MESSAGES.PASSWORD_CHAR_LIMIT },
    { regex: textLowerCaseRegex, errorMessage: ERROR_MESSAGES.PASSWORD_LOWERCASE },
    { regex: textUpperCaseRegex, errorMessage: ERROR_MESSAGES.PASSWORD_UPPERCASE },
    { regex: digitRegex, errorMessage: ERROR_MESSAGES.PASSWORD_DIGIT },
    { regex: spaceRegex, errorMessage: ERROR_MESSAGES.PASSWORD_NO_SPACES },
    { regex: specialCharRegex, errorMessage: ERROR_MESSAGES.PASSWORD_SPECIAL_CHAR }
];
